<template>
    <MasterTemplate 
        title="ข้อมูลประกัน" 
        :headers="headers" 
        :setData="setData"
        itemKey="insId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
    <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="รหัสประกัน" outlined autofocus maxlength="20" v-model="editedItem.insCode" :rules="[rules.required, chkCode] "></v-text-field>
                </v-col>
                <v-col cols="8" >
                    <v-text-field  label="ชื่อประกัน" outlined maxlength="100" v-model="editedItem.insName" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="8" >
                    <v-text-field  label="ชื่อย่อประกัน" outlined maxlength="100" v-model="editedItem.insNickName" ></v-text-field>
                </v-col>
            </v-row>
  <v-data-table
    :headers="subHeaders"
    :items="editedItem.discountList"
    item-key="branchCode"
    style="border:1px solid; border-color:#808080"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>ข้อมูลส่วนลดประกัน</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="subDialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >เพิ่ม</v-btn>
          </template> 
             <v-form ref="subForm" lazy-validation>
          <v-card>
            <v-card-title>ส่วนลดประกัน</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container>
                <v-row v-if="!isUpdate"> 
                  <!-- v-if="!isUpdate" -->
                  <!-- <v-col cols="12" sm="6" md="4" >
                     <v-text-field outlined v-model="discount.branchCode" :rules="[rules.required]" label="สาขา"></v-text-field>
                  </v-col> -->
                  
                    <v-col cols="5">
                       
                                                                    <v-select
                                                                    v-model="selectedBranch"
                                                                        :items="usedBranch"
                                                                        label="สาขา"
                                                                        item-text="name"
                                                                        item-value="value"
                                                                        :rules="[subRules.required]"
                                                                        return-object
                                                                        outlined placeholder="เลือกสาขา"
                                                                    ></v-select>
                                                                </v-col> 
                </v-row>
                  <v-row> ส่วนลดอะไหล่ </v-row>
                   <v-row>
                  <v-col cols="12" sm="6" md="4">                    
                    <v-text-field type="number" outlined v-model="discount.mallPartDiscount" :rules="[rules.required]" label="ซ่อมห้าง"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field type="number" outlined v-model="discount.garagePartDiscount" :rules="[rules.required]" label="ซ่อมอู่"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>ส่วนลดค่าแรง </v-row>
                   <v-row>
                  <v-col cols="12" sm="6" md="4">                    
                    <v-text-field type="number" outlined v-model="discount.mallLaborDiscount" :rules="[rules.required]" label="ซ่อมห้าง"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field type="number" outlined v-model="discount.garageLaborDiscount" :rules="[rules.required]" label="ซ่อมอู่"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeSubItem">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="saveSubItem ">Save</v-btn>
            </v-card-actions>
          </v-card>
         </v-form>
        </v-dialog>
      </v-toolbar>
    </template>
      <template v-slot:item.actions="{ item }">
       <v-icon
        small
        class="mr-2"
        @click="editSubItem(item)"
      >
        mdi-pencil
      </v-icon>
     
      <v-icon
       small
      @click="deleteSubItem(item)"
      >
      mdi-delete
      </v-icon>
    </template> 

     <template v-slot:header.partDiscount>
                                <thead>
                                    <tr>
                                        <th colspan="2" class="text-center">ส่วนลดอะไหล่</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center pa-4" width="5%">ซ่อมห้าง</th>                                        
                                        <th class="text-center pa-4" width="5%">ซ่อมอู่</th>
                                    </tr>
                                </thead>
     </template>
      <template v-slot:item.partDiscount="{item}">
                                <tr>
                                                          
                                    <th class="text-center pa-4" width="5%">{{item.mallPartDiscount}}</th>
                                     <th class="text-center pa-4" width="5%">{{item.garagePartDiscount}}</th>   
                                </tr>
    </template>

    <template v-slot:header.LaborDiscount>
                                <thead>
                                    <tr>
                                        <th colspan="2" class="text-center">ส่วนลดค่าแรง</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center pa-4" width="5%">ซ่อมห้าง</th>                                        
                                        <th class="text-center pa-4" width="5%">ซ่อมอู่</th>
                                    </tr>
                                </thead>
     </template>
      <template v-slot:item.LaborDiscount="{item}">
                                <tr>
                                    <th class="text-center pa-4" width="5%">{{item.mallLaborDiscount}}</th>
                                     <th class="text-center pa-4" width="5%">{{item.garageLaborDiscount}}</th>   
                                </tr>
    </template>
  </v-data-table>

    </template> 
    </MasterTemplate>
</template>

<script>
    /* eslint-disable */
    import MasterTemplate from '@/components/MasterTemplate'
    import {listInsurance,listInsuranceByInsId,isExistInsuranceCode,insertInsurance,updateInsurance,deleteInsurance}
    from '@/api/master/insurance-api.js'
    import {listDropdownBranch} from '@/api/common/dropdown-api.js'
  
  export default {
    name: 'Insurance',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสประกันซ้ำ';
            return true;
        },
        isUpdate(){
            return this.flagSubUpdate != false ? true : false;
        }
    },
    watch: {
        'editedItem.insCode': function(newVal) {
            if (!this.editedItem.insId) {
                this.editedItem.insId = -1;
            }
            if (newVal && this.editedItem.insId) {

                isExistInsuranceCode(newVal, this.editedItem.insId).then(response => {
                    this.isDup = response;
                }).catch(()=>{
                    this.isDup = false;
                });
            }
        },
        subDialog(value) { 
          if (value) {
            listDropdownBranch().then(rs => {
              this.usedBranch = [];//rs.data;
              if(this.flagSubUpdate){
                    this.usedBranch = rs.data;
              }else{
                    rs.data.forEach((v, i) => {
                        if (this.editedItem.discountList && this.editedItem.discountList.length > 0) {                            
                            let disc = this.editedItem.discountList.find(d => {
                                return d.branchCode == v.value;
                            });
                            if (!disc) {
                                this.usedBranch.push(v);
                            }
                        } else {
                            this.usedBranch.push(v);
                        }
                    });
              }
              
            });
        }
     }
    },
    data: () => ({
        subDialog: false,
        isDup: false,
        headers: [
            {text: 'รหัสประกัน', value: 'insCode'},
            {text: 'ชื่อประกัน', value: 'insName'},
            {text: 'ชื่อย่อประกัน', value: 'insNickName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        subHeaders: [
            {text: 'สาขา', value: 'branchName'},
             {text: 'ส่วนลดอะไหล่', value: 'partDiscount' , sortable: false},
             {text: 'ส่วนลดค่าแรง', value: 'LaborDiscount', sortable: false},
            {text: 'Actions', value: 'actions', sortable: false}
        ],
        editedItem: {
            insId: '-1',
            insCode: '',
            insName: '',
            insNickName: '',
           discountList: []
        },
         defaultItem: {
            insId: '-1',
            insCode: '',
            insName: '',
            insNickName: '',
           discountList: []
        },
        discount: [],
        usedBranch: [],
        selectedBranch: {},
        flagSubUpdate: false,
        editSubItemIndex: -1,
        subRules: {
            required: value => {
                return value ? true : 'Required.';
            }
        }

    }),
    methods: {
        listData() {
            //console.log(this.$store.state.username);
            return listInsurance();
        },
        deleteData(item) {
            return deleteInsurance(item.insId);
        },
        insertData() {
            console.log(this.editedItem.discountList);
            return insertInsurance(this.editedItem);
        },
        updateData() {
            return updateInsurance(this.editedItem);
        },
        getItemName(item) {
            return item.insName;
        },
        setData(item) {
             if (item.insId && item.insId != '-1') {
                listInsuranceByInsId(item.insId).then(rs => {
                    this.editedItem = rs;
                    if (!this.editedItem.discountList) {
                        this.editedItem.discountList = Object.assign([], []);
                    }
                    
                });
            } else {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedItem.discountList =  Object.assign([], []);
           }
        },
        saveSubItem(){

            if (!this.$refs.subForm.validate()) {
                return;
            }

            if(this.flagSubUpdate){
                Object.assign(this.editedItem.discountList[this.editSubItemIndex], this.discount);

            }else{
                this.discount.branchCode = this.selectedBranch.value;
                this.discount.branchName = this.selectedBranch.name;
                let data = Object.assign({}, this.discount);
                this.editedItem.discountList.push(data);

            }
            this.discount = Object.assign({}, {});
            this.selectedBranch = Object.assign({}, {});
            this.subDialog = false;
            this.flagSubUpdate = false;
            console.log( this.editedItem.discountList);
        },
         editSubItem(subItem) {
           this.flagSubUpdate = true;
           this.editSubItemIndex = this.editedItem.discountList.indexOf(subItem);
           this.discount = Object.assign({}, subItem);
           this.subDialog = true;
        },
        deleteSubItem(subItem) {
            var result = confirm("ต้องการลบข้อมูลนี้หรือไม่?");
            if (result) {
                let index = this.editedItem.discountList.indexOf(subItem);
                this.editedItem.discountList.splice(index, 1);
            }
        },
        closeSubItem() {
            this.discount = Object.assign({}, {});
            this.selectedBranch = Object.assign({}, {});
            this.subDialog = false;
            this.flagSubUpdate = false;
        }
    }
    ,mounted() {

     }
}
</script>